import { render, staticRenderFns } from "./AcompanhamentoView.vue?vue&type=template&id=664c6fc6&"
import script from "./AcompanhamentoView.vue?vue&type=script&lang=js&"
export * from "./AcompanhamentoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports